import { CHANGE_HPRINTER_STATE } from "./types";

export const changeHprinterState = hprinterState => dispatch => {
  dispatch({
    type: CHANGE_HPRINTER_STATE,
    payload: hprinterState
  });
};
